module.exports = __webpack_public_path__ + "media/images/people/3-b505f758152775673b2d2041f48fa10f.jpg";